import { ApplicationScheme } from '../../../customers/types';
import { FormValues } from '../../types';

const getIndividualApplicationBody = (
  values: FormValues,
  basePersonalInfoEditable: boolean,
  applicationScheme?: ApplicationScheme,
) => {
  const body: FormValues = {};

  if (values.dob && basePersonalInfoEditable) {
    const dob = new Date(values?.dob);
    const formattedDob = `${dob.getFullYear()}-${(dob.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${dob.getDate().toString().padStart(2, '0')}`;

    body.dob = formattedDob;
  }

  if (values.firstName && basePersonalInfoEditable) {
    body.firstName = values.firstName;
  }

  if (values.lastName && basePersonalInfoEditable) {
    body.lastName = values.lastName;
  }

  if (values.nationalityId) {
    body.nationalityId = values.nationalityId;
  }

  if (values.email && basePersonalInfoEditable) {
    body.email = values.email;
  }

  if (values.clientActivityId) {
    body.clientActivityId = values.clientActivityId;
  }

  if (values.sourceOfFundsIds && values.sourceOfFundsIds.length) {
    body.sourceOfFundsIds = values.sourceOfFundsIds;
  }

  if (values.sourceOfFundsDescription) {
    body.sourceOfFundsDescription = values.sourceOfFundsDescription;
  }

  if (values.deliveryChannelId) {
    body.deliveryChannelId = values.deliveryChannelId;
  }

  if (values.productIds && values.productIds.length) {
    body.productIds = values.productIds;
  }

  if (values.nameOfEmployer) {
    body.nameOfEmployer = values.nameOfEmployer;
  }

  if (values.employeePosition) {
    body.employeePosition = values.employeePosition;
  }

  if (values.countryOfEmployerId) {
    body.countryOfEmployerId = values.countryOfEmployerId;
  }

  if (values.typeOfActivityDescription) {
    body.typeOfActivityDescription = values.typeOfActivityDescription;
  }

  if (values.monthlyTurnoverRangeId) {
    body.monthlyTurnoverRangeId = values.monthlyTurnoverRangeId;
  }

  if (values.monthlyNumberIncomingTransactionsRangeId) {
    body.monthlyNumberIncomingTransactionsRangeId =
      values.monthlyNumberIncomingTransactionsRangeId;
  }

  if (values.monthlyNumberOutgoingTransactionsRangeId) {
    body.monthlyNumberOutgoingTransactionsRangeId =
      values.monthlyNumberOutgoingTransactionsRangeId;
  }

  if (values.monthlyValueIncomingTransactionsRangeId) {
    body.monthlyValueIncomingTransactionsRangeId =
      values.monthlyValueIncomingTransactionsRangeId;
  }

  if (values.monthlyValueOutgoingTransactionsRangeId) {
    body.monthlyValueOutgoingTransactionsRangeId =
      values.monthlyValueOutgoingTransactionsRangeId;
  }

  if (values.monthlyMaxValueIncomingPaymentRangeId) {
    body.monthlyMaxValueIncomingPaymentRangeId =
      values.monthlyMaxValueIncomingPaymentRangeId;
  }

  if (values.monthlyMaxValueOutgoingPaymentRangeId) {
    body.monthlyMaxValueOutgoingPaymentRangeId =
      values.monthlyMaxValueOutgoingPaymentRangeId;
  }

  if (values.reviewDuplicatesComment) {
    body.reviewDuplicatesComment = values.reviewDuplicatesComment;
  }

  if (values.taxNumber) {
    body.taxNumber = values.taxNumber;
  }

  if (applicationScheme?.id === 'ed560559-8354-4634-b6dd-eb341dfb551a') {
    if (values.placeOfBirth) {
      body.placeOfBirth = values.placeOfBirth;
    }

    if (values.birthCountryId) {
      body.birthCountryId = values.birthCountryId;
    }

    body.correspondenceAddressSameAsRegisteredAddress =
      values.correspondenceAddressSameAsRegisteredAddress;

    if (values.correspondenceCountryId) {
      body.correspondenceCountryId = values.correspondenceCountryId;
    }

    if (values.correspondenceCity) {
      body.correspondenceCity = values.correspondenceCity;
    }

    if (values.correspondencePostalCode) {
      body.correspondencePostalCode = values.correspondencePostalCode;
    }

    if (values.correspondenceAddress1) {
      body.correspondenceAddress1 = values.correspondenceAddress1;
    }

    if (values.correspondenceAddress2) {
      body.correspondenceAddress2 = values.correspondenceAddress2;
    }
  }

  return body;
};

export default getIndividualApplicationBody;
